import PackageListTable from './packageListTable.container';

export default PackageListTable